// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React from 'react';
import {Settlement_notification_bar} from './settlement_notification_bar';
import {Settlement_popup} from './settlement_popup';
import {Settlement_login_popup} from './settlement_login_popup';
import {Settlement_done_popup} from './settlement_done_popup';
import {use_settlement_notification} from './use_sa2025';

interface i_settlement_ui_props {
    top_portal_ref: any;
}

export const Settlement_ui = (props: i_settlement_ui_props)=>{
    const {top_portal_ref} = props;
    const sa = use_settlement_notification();
    return <>
      <Settlement_notification_bar
        is_visible={sa.notification_visible}
        on_learn_more_click={sa.on_learn_more_click}
        portal_ref={top_portal_ref}
      />
      <Settlement_popup
        is_open={sa.is_open}
        on_close={sa.on_close}
        on_receive_benefit={sa.on_receive_benefit}
        is_client={sa.is_client}
        benefit_type={sa.benefit_type}
        benefit_value={sa.benefit_value}
      />
      <Settlement_login_popup
        is_open={sa.login_popup_is_open}
        on_close={sa.login_popup_on_close}
        on_signin={sa.login_popup_on_signin}
        is_client={sa.is_client}
      />
      <Settlement_done_popup
        is_open={sa.done_popup_is_open}
        on_close={sa.done_popup_on_close}
        on_got_it={sa.done_popup_on_got_it}
        is_client={sa.is_client}
        benefit_value={sa.benefit_value}
      />
    </>;
};
